/**
Project: Voice Panel (c)
Title: Routing 
Description: Component to dispay the Routing Page
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import { 
  Flex, 
  // Text 
} from "@fluentui/react-northstar";
import axios from "axios";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import RoutingPage from "./routing-page";
import { manageError } from "../../../../core/actions/common-actions";
import { hidePageWaitDialog } from "../../common/actions/general-actions";

class Routing extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_vpa_routing = "vpa_routing";

  constructor(props) {
    super(props);
    this.state = {};
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
    await this.loadPageData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  loadPageData = async () => {
    try {
      await this.props.hidePageWaitDialog();
    } catch (err) {
      await manageError(err, this.props.history);
    }
  };

  render() {
    return (
      <Flex column className="page-wrapper">
        {/* <Flex column className="page-title-wrapper">
          <Text className="page-title-text">
            {IntlUtil.getText(this._intl_ns_vpa_routing, "content.routing")}
          </Text>
        </Flex> */}
        <Flex column className="page-content p-5">
          <RoutingPage history={this.props.history} />
        </Flex>
      </Flex>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapActionToProps = { hidePageWaitDialog };

export default connect(mapStateToProps, mapActionToProps)(Routing);
